import { CTABannerRefProjection } from '../references/CTABannerRef.query';

export const spotlightQuery = groq`*[_type == 'spotlight' && currentPathname == $currentPathname][0]{
  ...,
  CTABanner {
    reference-> ${CTABannerRefProjection}
  }
}`;
